export default {
    props: {
        selectableKey: {
            type: String,
            default: undefined,
            kComposite: 'selectable.key'
        }, 
        selectableMultiple: {
            type: Boolean,
            default: undefined,
            kComposite: 'selectable.multiple'
        }, 
        selectableStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'selectable.stroke.color'
        }, 
        selectableStrokeDashType: {
            type: String,
            default: undefined,
            kComposite: 'selectable.stroke.dashType'
        }, 
        selectableStrokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'selectable.stroke.width'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-diagram-vue-wrapper/src/KendoDiagram/Selectable.js